import { getCountryCode as getCountryCodeFromUtils } from 'common-utils';

export function getCountryCode() {
  return getCountryCodeFromUtils();
}
